export default __webpack_public_path__ + "static/media/logo.19cbf7dc.webp";